function t(e,o){return t=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},t(e,o)}export{t as default};
//# sourceMappingURL=setPrototypeOf.js.map
